import { useEffect } from "react";
import "./App.css";

function App() {
  useEffect(() => {
    // Don't redirect if we're in /admin path
    if (window.location.pathname.startsWith('/admin')) {
      return;
    }
    
    // Redirect only if we're on root path and there's no existing static content
    if (window.location.pathname === '/' && !document.querySelector('title')?.textContent?.includes('Fix&Print')) {
      window.location.href = '/index.html';
    }
  }, []);

  // If we're on /admin path, don't render React app
  if (window.location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <div className="min-h-screen flex items-center justify-center" 
         style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
      <div className="text-center text-white">
        <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mb-6"></div>
        <h1 className="text-4xl font-bold mb-2">Fix&Print</h1>
        <p className="text-xl opacity-90">Loading static site...</p>
        <p className="mt-4">
          <a href="/index.html" className="text-blue-200 hover:text-white underline">
            Click here if not redirected automatically
          </a>
        </p>
      </div>
    </div>
  );
}

export default App;
